import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {withResponsiveHelper} from '@modifi/ui'
import DefaultCarosel from '../../common-components/default-carousel'
import FlippableCard from './FlippableCard'
import {DefaultComponentWrapper} from '../common'
import {FlippableWrapper} from './styles'

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      description: PropTypes.string,
    }).isRequired
  ),
  isXsOrSmaller: PropTypes.bool,
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  cards: [],
  isXsOrSmaller: false,
  backgroundColor: undefined,
}

export type FlippableCardsProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const FlippableCards: React.FC<FlippableCardsProps> = ({
  cards,
  isXsOrSmaller,
  backgroundColor,
}) => {
  const cardsMap =
    // eslint-disable-next-line react/no-array-index-key
    cards?.map((props, i) => <FlippableCard key={`flip-card-${i}`} cardDetails={props} />) ?? []

  return (
    <DefaultComponentWrapper backgroundColor={backgroundColor}>
      {isXsOrSmaller ? (
        <DefaultCarosel>{cardsMap}</DefaultCarosel>
      ) : (
        <FlippableWrapper>{cardsMap}</FlippableWrapper>
      )}
    </DefaultComponentWrapper>
  )
}

FlippableCards.propTypes = propTypes

FlippableCards.defaultProps = defaultProps

export default withResponsiveHelper(FlippableCards)
